<app-abstract-action-confirmation-dialog
  (acceptEvent)="onAcceptClickedHandler()"
  (closeEvent)="onCloseClickedHandler()"
  (declineEvent)="onDeclineClickedHandler()"
  [acceptLabel]="data.acceptLabel"
  [cdkFocusInitialOnCancelButtonFlag]="data.cdkFocusInitialOnCancelButtonFlag"
  [declineLabel]="data.declineLabel"
  [formGroup]="formGroup"
  [messageLine1]="data.messageLine1"
  [messageLine2]="data.messageLine2"
  [note]="data.note"
  [subMessageLine1]="data.subMessageLine1"
  [subMessageLine2]="data.subMessageLine2"
>
  <div popup-form>
    <form [formGroup]="formGroup">
      <div class="detail-card mt-32 fxsa-center fxl-row fxla-start-center fxg-row-12px">
        <mat-icon class="detail-text s-20">info</mat-icon>
        <div [innerHTML]="information" class="information-message"></div>
      </div>
    </form>
  </div>
</app-abstract-action-confirmation-dialog>
